import PreOrder from '@/pages/order/PreOrder.vue'
import QuickOrder from '@/pages/order/QuickOrder.vue'
import Confirm from '@/pages/order/Confirm.vue'
import Cashier from '@/pages/order/Cashier.vue'

// 前端订单相关路由数组
export const orderRoutes = [

  {
    path: '/preorder/:preorderNumber',
    name: 'PreOrder',
    component: PreOrder,
    meta: {
      title: '租赁预订单'
    }
  },
  {
    path: '/quickorder',
    name: 'QuickOrder',
    component: QuickOrder,
    meta: {
      title: '快速预订'
    }
  },
  {
    path: '/confirm',
    name: 'Confirm',
    component: Confirm,
    meta: {
      title: '确认订单',
      requireAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/cashier/:orderNumber',
    name: 'Cashier',
    component: Cashier,
    meta: {
      title: '结算中心',
      requireAuth: true // 需要登录才能访问
    }
  }
]

export default orderRoutes



// WEBPACK FOOTER //
// ./src/router/order.js